// extracted by mini-css-extract-plugin
module.exports = {"markdown":"_1nLRt","description":"_2HePa"};